import { injectable } from 'inversify';
import { ReadmissionHistory } from '../services/ReadmissionManagerRunner';
import { ReadmissionStorageInterface } from '../interfaces/ReadmissionStorageInterface';

export class ReadmissionHistoryDTO {
  constructor(public key: string, public admissionDate: string, public prevAdmission: ReadmissionHistory | undefined) { }
}

export class ReadmissionCacheDTO {
  constructor(public key: string, public arrayOfReadmission: Array<ReadmissionHistoryDTO>) { }
}

export type ReadmissionCache = Map<string, Array<ReadmissionHistory>>;

@injectable()
export class LocalReadmissionStorage implements ReadmissionStorageInterface {
  protected storage = window.localStorage;
  protected cache: ReadmissionCache = new Map<string, Array<ReadmissionHistory>>();
  protected STORAGE_ITEM_KEY = 'HashCacheStorage';

  constructor() {
    this.cache = this.getCache();
    if (!this.storage.getItem(this.STORAGE_ITEM_KEY)) {
      this.storage.setItem(this.STORAGE_ITEM_KEY, JSON.stringify(this.transformMapToArray()));
    }
  }

  async save(cryptedHash: string, otherAdmission: ReadmissionHistory[]) {
    this.cache.set(cryptedHash, otherAdmission!);
    this.storage.setItem(this.STORAGE_ITEM_KEY, JSON.stringify(this.transformMapToArray()));
    return Promise.resolve();
  }

  //Delete the chain at the index with this cryptedHash
  async delete(cryptedHash: string, index: number) {
    const readmissionHistories = this.cache.get(cryptedHash);

    if (!readmissionHistories) {
        return;
    }

    if (index === undefined) {
      this.cache.delete(cryptedHash);
    } else {
      readmissionHistories.splice(index, 1);

      if (readmissionHistories.length === 0) {
          this.cache.delete(cryptedHash);
      } else {
          this.cache.set(cryptedHash, readmissionHistories);
      }
    }

    this.storage.setItem(
        this.STORAGE_ITEM_KEY,
        JSON.stringify(this.transformMapToArray())
    );
}

  protected transformMapToArray(): Array<ReadmissionCacheDTO> {
    const temporaryCacheDTOArray: Array<ReadmissionCacheDTO> = new Array<ReadmissionCacheDTO>();
    let temporaryMapStringDateArray: Array<ReadmissionHistoryDTO> =
      new Array<ReadmissionHistoryDTO>();

    this.cache.forEach((value, key) => {
      value.forEach((readmission) => {
        const tempMapStringDate = new ReadmissionHistoryDTO(readmission.caseId, readmission.admissionDate, readmission.prevAdmission);
        temporaryMapStringDateArray.push(tempMapStringDate);
      });
      const tempCacheDTO = new ReadmissionCacheDTO(key, temporaryMapStringDateArray);
      temporaryCacheDTOArray.push(tempCacheDTO);
      temporaryMapStringDateArray = [];
    });
    return temporaryCacheDTOArray;
  }

  async getPrevAdmissionsHypothesis(cryptedHash: string): Promise<Array<ReadmissionHistory> | undefined> {
    return this.cache.get(cryptedHash);
  }

  protected getCache(): ReadmissionCache {
    const result: ReadmissionCache = new Map();
    const stringSaved = JSON.parse(
      this.storage.getItem(this.STORAGE_ITEM_KEY) ?? '[]'
    ) as Array<ReadmissionCacheDTO>;

    stringSaved.forEach((singleCacheDTO: ReadmissionCacheDTO) => {
      singleCacheDTO.arrayOfReadmission.forEach((singleMapStringDate: ReadmissionHistoryDTO) => {

        if (result.get(singleCacheDTO.key)) {

          const oldResult = result.get(singleCacheDTO.key);
          oldResult?.push({
            caseId: singleMapStringDate.key,
            admissionDate: singleMapStringDate.admissionDate,
            prevAdmission: singleMapStringDate.prevAdmission
          })
          result.set(
            singleCacheDTO.key,
            oldResult!)
        } else {
          result.set(
            singleCacheDTO.key,
            [{
              caseId: singleMapStringDate.key,
              admissionDate: singleMapStringDate.admissionDate,
              prevAdmission: singleMapStringDate.prevAdmission
            }]
          )
        }

      });
    });
    return result;
  }
}
